import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-legal-entity-selector-header',
    templateUrl: './legal-entity-selector-header.component.html',
    styleUrl: './legal-entity-selector-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LegalEntitySelectorHeaderComponent {
  countries: unknown[] | undefined;

  selectedCountry: string | undefined;
}
